var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 18.4C13.2002 18.4 13.4002 18.3 13.5002 18.2L19.0002 12.7C19.1002 12.6 19.1002 12.5 19.1002 12.5C19.2002 12.4 19.2002 12.3 19.2002 12.2C19.2002 12.1 19.2002 12 19.1002 11.9C19.1002 11.8 19.0002 11.7 18.9002 11.7L13.4002 6.2C13.4002 6.1 13.2002 6 13.0002 6C12.8002 6 12.6002 6.1 12.5002 6.2C12.4002 6.3 12.3002 6.5 12.3002 6.7C12.3002 6.9 12.4002 7.1 12.5002 7.2L16.8002 11.5H5.7002C5.5002 11.5 5.3002 11.6 5.2002 11.7C5.10019 11.8 5.0002 12 5.0002 12.2C5.0002 12.4 5.10019 12.6 5.2002 12.7C5.3002 12.8 5.5002 12.9 5.7002 12.9H16.8002L12.5002 17.2C12.4002 17.3 12.3002 17.5 12.3002 17.7C12.3002 17.9 12.4002 18.1 12.5002 18.2C12.6002 18.3 12.8002 18.4 13.0002 18.4Z",
    fill: "#33303C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b40093fbabf2b683044e3f7b5a2dfb5a.svg";
export { ForwardRef as ReactComponent };